import styled from 'styled-components';
import { GDBREAKPOINTS_NUM } from '@gameday/components/themes/breakpoints';
import { PlayerDataWrapper, PlayerNameWrapper } from '@mlb/react-patterns/components/PlayerMatchup/playerMatchup.style';
import Card from '../Card/Card';
import { MatchupWrapper } from '../Matchup/Matchup.style';
import { MatchupWrapper as PlayerDuelMatchupWrapper, PlayerDuelStatsWrapper, ProbablePitcherInfoWrapper } from '../PlayerDuel/PlayerDuel.style';
import Button from '@mlb/react-patterns/components/Button/button';

const {
    MD,
    LG
} = GDBREAKPOINTS_NUM;

const mobileWidth = MD + 'px';
const tabletWidth = LG - 1 + 'px';

export const PreviewWrapper = styled.div`
  max-width: 1056px; // lock the max width in 1024px + padding (16px on each side)
  margin: 0 auto;
  width: 100%;
`;

export const StyledCard = styled(Card)`
  margin:16px;
  margin-top: 24px;
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 8px;

  @media (max-width: ${tabletWidth}){
     margin-left: 0;
     margin-right: 0;
     margin-top: 0;
     border-radius: 0;
     padding-top: 16px;
     border-bottom: 1px solid var(--gameday-divider-color);
     box-shadow: none;
  }

`;

export const PreviewSubWrapper = styled.div`
  
  @media (max-width: ${mobileWidth}){
    margin-left: 16px;
    margin-right: 16px;
  }
`;

export const PreviewGameInfoWrapper = styled(Card)`
    width: 50%;
    font-family: var(--gameday-primary-font);
    margin: 0 16px;
    @media (max-width: ${tabletWidth}){
      margin: 0;
    }

    @media (max-width: ${mobileWidth}){
      width: calc(100% - 32px);
      display: block;
      box-sizing: content-box !important;
      margin-bottom: 24px;
    }

    ${MatchupWrapper} {
      padding: 0px;
    }

    ${PlayerDuelMatchupWrapper} {
      padding: 0;
      justify-content: space-evenly;
      width: 100%;

      @media (max-width: ${mobileWidth}){
        padding-top: 0;

      }

    }

    ${PlayerDataWrapper} {
      margin-top: 2px;
    }

    ${PlayerNameWrapper} {
      font-weight: 700;
      font-size: 18px;
      line-height: 26px;
      color: var(--gameday-primary-font-color);
    }

    ${PlayerDuelStatsWrapper} {
      font-size: 14px;
      color: var(--gameday-primary-font-color);
    }
    ${ProbablePitcherInfoWrapper} {
      color: var(--gameday-secondary-font-color);
      font-size: 14px;
      font-weight: 500;
    }

`;

export const Title = styled.div`
  font-size: var(--gameday-preview-card-title-font-size);
  line-height: var(--gameday-preview-card-title-line-height);
  font-weight: var(--gameday-card-title-font-weight);
  color: var(--gameday-card-title-color);
  margin-bottom: 16px;
  font-family: var(--gameday-primary-font);
`;

export const ProbablePitchersFollowWrapper = styled.div`
  
@media (min-width: ${mobileWidth}){
    display: flex;
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 24px;
  }

  ${PreviewGameInfoWrapper}  {
    align-self: stretch;

    &:first-child {
      margin-left:0;

      @media (min-width: ${mobileWidth}){
        order: 2;
        margin-left:16px;
      }
    }

    &:last-child {
      margin-right:0;

      @media (min-width: ${mobileWidth}){
        order: 1;
        margin-right:16px;
      }
    }

    @media (max-width: ${MD - 1}px){  
      &:first-child {
        margin-bottom: 16px;
      }
    }
  } 

`;


export const PreviewLineupMatchupWrapper = styled.div`
    margin-left: 16px;
    margin-right: 16px;
    margin-top:24px;
    @media (max-width: ${tabletWidth}){
      margin-left: 0;
      margin-right: 0;
    }
`;


export const TicketButton = styled(Button)`
    height: 48px;
    border-radius: 40px;
    font-size: 14px;
    width: 122px;
    @media (max-width: ${mobileWidth}){
      width: 100%; 
    }
    background-color: var(--gameday-button-solid-background);
`;

export const TicketWrapper = styled.div`
    margin-top: var(--gameday-section-padding-sm);
    padding-bottom: 0;
    >div {
        display: inline-block;
    }
    @media (min-width: ${MD}) {
        padding: var(--gameday-section-padding-sm) 0px 0px 0px;
    }

`;